"use client";

import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

interface ThreeDMarqueeProps {
  columns: { src: string }[][] | string[][];
  className?: string;
  wrapperClassName?: string; // width + scale div
  gridClassName?: string; // grid layout classes
  gridStyle?: React.CSSProperties; // custom inline styles (like rotation)
  imageClassName?: string;
  transitionDurations?: {
    evenColumnDuration: number;
    oddColumnDuration: number;
  };
}

export const ThreeDMarquee = ({
  columns,
  className,
  wrapperClassName = "w-[1450px] scale-[0.45] sm:scale-[0.65] lg:scale-[1] 2xl:scale-[1.5]",
  gridClassName = "grid origin-top-center grid-cols-8 xl:grid-cols-6 gap-6 transform",
  gridStyle = {
    transform: "rotateX(0deg) rotateY(0deg) rotateZ(10deg)",
  },
  imageClassName = "object-contain ring ring-gray-200/30 hover:shadow-xl border-2 border-white rounded-[4px] shadow-[0px_4px_34.3px_rgba(0,0,0,0.07)]",
  transitionDurations = { evenColumnDuration: 10, oddColumnDuration: 15 },
}: ThreeDMarqueeProps) => {
  return (
    <div className={cn("mx-auto h-[600px]", className)}>
      <div className="flex h-full items-center justify-center">
        <div className={cn(wrapperClassName)}>
          <div className={cn(gridClassName)} style={gridStyle}>
            {columns.map((column, colIndex) => (
              <motion.div
                key={`col-${colIndex}`}
                className="flex flex-col gap-6"
                animate={{ y: colIndex % 2 === 0 ? 100 : -100 }}
                transition={{
                  duration: colIndex % 2 === 0 ? transitionDurations.evenColumnDuration : transitionDurations.oddColumnDuration,
                  repeat: Infinity,
                  repeatType: "reverse",
                }}
              >
                {column.map((img, i) => (
                  <motion.img
                    key={`img-${colIndex}-${i}`}
                    src={typeof img === "string" ? img : img.src}
                    alt={`Project Img ${i + 1}`}
                    whileHover={{ y: -10 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                    className={cn(imageClassName)}
                  />
                ))}
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
